import React from "react";
import Promotion from "./Promotion";

const ctaItems = [
    {
        icon: "bi-envelope",
        title: "Enquire Now",
        desc: "Have questions? Get in touch with our team and we'll help you get started on your educational journey.",
        buttonText: "Contact Us",
        buttonLink: "/contact"
    },
    {
        icon: "bi-file-earmark-text",
        title: "Apply Now",
        desc: "Ready to get started? Submit your application today and take the first step towards prosperity and excellence.",
        buttonText: "Start Application",
        buttonLink: "/apply"
    },
    {
        icon: "bi-bookmark-star",
        title: "Programmes",
        desc: "Explore our wide range of programmes designed to meet your educational and professional aspirations.",
        buttonText: "View Programmes",
        buttonLink: "/courses"
    },
];


const WhyUs = () => (
    <section id="why-us" className="py-16">
        <div className="container mx-auto px-4 grid md:grid-cols-3 gap-8 items-stretch">
            <Promotion />
            <div className="md:col-span-2 grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-aos="fade-up" data-aos-delay="200">
                {ctaItems.map((item, i) => (
                    <div key={i} className="p-6 border rounded-lg flex flex-col text-center shadow hover:shadow-lg transition bg-white">
                        <i className={`bi ${item.icon} text-green-600 text-4xl mb-4`}></i>
                        <h4 className="font-bold text-lg mb-3">{item.title}</h4>
                        <p className="text-sm text-gray-600 mb-6 flex-grow">{item.desc}</p>
                        <a
                            href={item.buttonLink}
                            className="inline-block bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-md font-semibold transition"
                        >
                            {item.buttonText}
                        </a>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default WhyUs;
